export const INTENT_MAX_AGE_MS = 30 * 60 * 1000;

const createIntentStore = (key, maxAgeMs = INTENT_MAX_AGE_MS) => {
  const clear = () => {
    try {
      sessionStorage.removeItem(key);
    } catch {
      /* sessionStorage unavailable */
    }
  };

  const save = (info) => {
    try {
      sessionStorage.setItem(key, JSON.stringify({ createdAt: Date.now(), ...info }));
    } catch {
      /* sessionStorage unavailable — the return trip just won't auto-resume */
    }
  };

  const read = () => {
    let intent = null;

    try {
      const raw = sessionStorage.getItem(key);

      intent = raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }

    if (!intent) return null;

    if (typeof intent.createdAt !== "number" || Date.now() - intent.createdAt > maxAgeMs) {
      clear();

      return null;
    }

    return intent;
  };

  const take = () => {
    try {
      return read();
    } finally {
      clear();
    }
  };

  return { save, read, take, clear };
};

export default createIntentStore;
